import React, {Component} from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import './DefineAvailabilityDialog.scss'
import CircularProgress from "@material-ui/core/es/CircularProgress/CircularProgress";
import _ from "lodash";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/CloseRounded";
import AvailableMessengersIcon from "../../../../Utils/Icons/SVGs/AvailableMessengersIcon";
import {Input, Tooltip} from "@material-ui/core";
import Fab from "@material-ui/core/Fab";
import PowerSettingsNewRoundedIcon from "@material-ui/icons/PowerSettingsNewRounded";


export default class DefineAvailabilityDialog extends Component {
    constructor(props) {
        super(props);

        this.state = {
            messengers: [...props.onShift].sort(DefineAvailabilityDialog.compareMessengersByAvailabilityTime),
            searchCourierText: ""
        };
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (nextProps.open && !this.props.open) {
            this.setState({
                messengers: [...nextProps.onShift].sort(DefineAvailabilityDialog.compareMessengersByAvailabilityTime),
                searchCourierText: ""
            })
        }
    }

    handleClose() {
        if (this.props.onClose)
            this.props.onClose();
    }

    handleToggle(uid, flag) {
        const newMessengers = [...this.state.messengers];

        const foundMessenger = newMessengers.find(user => user.id === uid);
        const newAvailabilityStatus = flag !== undefined ? flag : !foundMessenger.profiles.messenger.isCurrentlyAvailable
        foundMessenger.profiles.messenger.isCurrentlyAvailable = newAvailabilityStatus;
        foundMessenger.profiles.messenger.isWhileMission = false;

        this.setState({
            messengers: newMessengers
        });

        this.props.updateMessengerAvailability(
            this.props.match.params.bid,
            uid,
            newAvailabilityStatus
        );
    }

    static compareMessengersByAvailabilityTime(a, b) {
        const aLastAvailable = _.get(a, "profiles.messenger.lastAvailableTimestamp", '0');
        const aLastNonAvailable = _.get(a, "profiles.messenger.lastNonAvailableTimestamp", '0');

        const bLastAvailable = _.get(b, "profiles.messenger.lastAvailableTimestamp", '0');
        const bLastNonAvailable = _.get(b, "profiles.messenger.lastNonAvailableTimestamp", '0');

        const aTimestamp = aLastAvailable > aLastNonAvailable ? aLastAvailable : aLastNonAvailable;
        const bTimestamp = bLastAvailable > bLastNonAvailable ? bLastAvailable : bLastNonAvailable;

        if (aTimestamp < bTimestamp)
            return 1;
        else if (aTimestamp > bTimestamp)
            return -1;

        return 0;
    }

    handleSearchCourierTextChange(e) {
        this.setState({
            searchCourierText: !e.target.value ? "" : e.target.value
        });
    }

    isTextIncludesTokenizedText(mainText, includedText) {
        const tokenizedIncludedText = includedText.split(" ");

        return tokenizedIncludedText.every(includedToken => mainText.toLowerCase().includes(includedToken.toLowerCase()));
    }

    filterUsersBySearch(users, searchText) {
        return !searchText ? users : users.filter(user => this.isTextIncludesTokenizedText(user.name, searchText));
    }

    render() {
        const {classes} = this.props;

        const messengers = this.filterUsersBySearch(this.state.messengers, this.state.searchCourierText);

        const available = messengers.filter(messenger => messenger.profiles.messenger.isCurrentlyAvailable);
        const notAvailable = messengers.filter(messenger => !messenger.profiles.messenger.isCurrentlyAvailable && !messenger.profiles.messenger.isWhileMission);
        const onMission = messengers.filter(messenger => !messenger.profiles.messenger.isCurrentlyAvailable && messenger.profiles.messenger.isWhileMission);

        return (
            <Dialog
                scroll={'paper'}
                className="define-availability-dialog"
                open={this.props.open}
                onClose={this.handleClose.bind(this)}
                aria-labelledby="form-dialog-title"
                PaperProps={{className: "define-availability-dialog-paper"}}>
                <DialogTitle id="form-dialog-title" className="dialog-title">
                    <div className="define-availability-dialog-title-content">
                        <AvailableMessengersIcon fontSize="37px"/>
                        &nbsp;
                        זמינות שליחים
                    </div>
                </DialogTitle>
                <DialogContent className="define-availability-dialog-content" dividers={true}>
                    {
                        this.props.fetching ?
                            <div className="loading-wrapper">
                                <CircularProgress/>
                            </div>
                            :
                            <div className="users-wrapper">
                                {
                                    this.state.messengers.length === 0 ?
                                        <div className="no-messengers-text">אין שליחים במשמרת</div>
                                        :
                                        <div className="available-notavailable-wrapper">
                                            <div className="search-courier-wrapper">
                                                <Input className="search-courier-input" placeholder="חיפוש שליח"
                                                       value={this.state.searchCourierText}
                                                       onChange={this.handleSearchCourierTextChange.bind(this)}/>
                                            </div>
                                            <div className="available-notavailable">
                                                <div className="availability-couriers-wrapper">
                                                    <div
                                                        className="availability-couriers-title availability-couriers-title-mission">
                                                        במהלך משימה
                                                    </div>
                                                    <div className="availability-couriers-list">
                                                        {
                                                            onMission.map(user =>
                                                                <div key={`availability-courier-${user.id}`}
                                                                     className="availability-courier">
                                                                    <div className="availability-courier-name">
                                                                        {user.name}
                                                                    </div>
                                                                    <div className="availability-courier-actions">
                                                                        <Tooltip enterDelay={500}
                                                                                 disableFocusListener={true} arrow
                                                                                 title="סיים משימה והפוך לזמין">
                                                                            <Fab
                                                                                className="availability-courier-action available-action"
                                                                                size="small"
                                                                                onClick={this.handleToggle.bind(this, user.id, true)}>
                                                                                <PowerSettingsNewRoundedIcon/>
                                                                            </Fab>
                                                                        </Tooltip>
                                                                        <div className="available-unavailable-spacer"/>
                                                                        <Tooltip enterDelay={500}
                                                                                 disableFocusListener={true} arrow
                                                                                 title="סיים משימה והפוך ללא זמין">
                                                                            <Fab
                                                                                className="availability-courier-action unavailable-action"
                                                                                size="small"
                                                                                onClick={this.handleToggle.bind(this, user.id, false)}>
                                                                                <PowerSettingsNewRoundedIcon/>
                                                                            </Fab>
                                                                        </Tooltip>
                                                                    </div>
                                                                </div>
                                                            )
                                                        }
                                                    </div>
                                                </div>
                                                <div className="availability-couriers-wrapper">
                                                    <div
                                                        className="availability-couriers-title availability-couriers-title-on">
                                                        זמינים
                                                    </div>
                                                    <div className="availability-couriers-list">
                                                        {
                                                            available.map(user =>
                                                                <div key={`availability-courier-${user.id}`}
                                                                     className="availability-courier">
                                                                    <div className="availability-courier-name">
                                                                        {user.name}
                                                                    </div>
                                                                    <div className="availability-courier-actions">
                                                                        <Tooltip enterDelay={500}
                                                                                 disableFocusListener={true} arrow
                                                                                 title="הפוך ללא זמין">
                                                                            <Fab
                                                                                className="availability-courier-action unavailable-action"
                                                                                size="small"
                                                                                onClick={this.handleToggle.bind(this, user.id, undefined)}>
                                                                                <PowerSettingsNewRoundedIcon/>
                                                                            </Fab>
                                                                        </Tooltip>
                                                                    </div>
                                                                </div>
                                                            )
                                                        }
                                                    </div>
                                                </div>
                                                <div className="availability-couriers-wrapper">
                                                    <div
                                                        className="availability-couriers-title availability-couriers-title-off">
                                                        לא זמינים
                                                    </div>
                                                    <div className="availability-couriers-list">
                                                        {
                                                            notAvailable.map(user =>
                                                                <div key={`availability-courier-${user.id}`}
                                                                     className="availability-courier">
                                                                    <div className="availability-courier-name">
                                                                        {user.name}
                                                                    </div>
                                                                    <div className="availability-courier-actions">
                                                                        <Tooltip enterDelay={500}
                                                                                 disableFocusListener={true} arrow
                                                                                 title="הפוך לזמין">
                                                                            <Fab
                                                                                className="availability-courier-action available-action"
                                                                                size="small"
                                                                                onClick={this.handleToggle.bind(this, user.id, undefined)}>
                                                                                <PowerSettingsNewRoundedIcon/>
                                                                            </Fab>
                                                                        </Tooltip>
                                                                    </div>
                                                                </div>
                                                            )
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                }
                            </div>
                    }
                    <div className="dialog-actions">
                        <IconButton className="close-button"
                                    onClick={this.handleClose.bind(this)}>
                            <CloseIcon fontSize="small"/>
                        </IconButton>
                    </div>
                </DialogContent>
            </Dialog>
        );
    }
}